import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, FormControl, InputLabel, Select, MenuItem, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { apiRequest } from '../../../utils/fetch';
import { AdSpaceMediaTypeInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const initialMediaType: Partial<AdSpaceMediaTypeInterface> = {
  name: '',
  description: '',
  active: true,
};

const AdSpaceMediaTypesAdminAddMediaTypePage: React.FC = () => {
  const [mediaType, setMediaType] = useState<Partial<AdSpaceMediaTypeInterface>>(initialMediaType);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (field: keyof AdSpaceMediaTypeInterface, value: any) => {
    setMediaType(a => ({ ...a, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const result = await apiRequest<GenericResponseInterface<AdSpaceMediaTypeInterface>>('/adSpaceMediaTypes/insert', 'POST', mediaType);
      if (result.status) {
        setSuccess(result.message || 'Media type created successfully!');
        setDialogOpen(true);
        setMediaType(initialMediaType);
      } else {
        setError(result.message || 'Failed to create media type');
        setDialogOpen(true);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create media type');
      setDialogOpen(true);
    }
  };


  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add New Ad Space Media Type</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Name"
          value={mediaType.name ?? ''}
          onChange={e => handleChange('name', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Description"
          value={mediaType.description ?? ''}
          onChange={e => handleChange('description', e.target.value)}
          fullWidth
          margin="dense"
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="active-label">Active</InputLabel>
          <Select
            labelId="active-label"
            value={mediaType.active !== undefined ? (mediaType.active ? 'yes' : 'no') : 'yes'}
            label="Active"
            onChange={e => handleChange('active', e.target.value === 'yes')}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary">
            Create Media Type
          </Button>
        </Box>
      </form>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{success ? 'Success' : 'Error'}</DialogTitle>
        <DialogContent>
          <Typography>{success || error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AdSpaceMediaTypesAdminAddMediaTypePage;